import { render } from "./Acquirer.vue?vue&type=template&id=5a3aa541&scoped=true"
import script from "./Acquirer.vue?vue&type=script&lang=js"
export * from "./Acquirer.vue?vue&type=script&lang=js"

import "./Acquirer.vue?vue&type=style&index=0&id=5a3aa541&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3aa541"]])

export default __exports__